import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const isRefreshCondition = (location: any, preLocation: any) => {
  const {
    hash, key, pathname, search,
  } = location;
  const {
    hash: preHash, key: preKey, pathname: prePathname, search: preSearch,
  } = preLocation;
  return (hash !== preHash || key !== preKey) && pathname === prePathname && search === preSearch;
};

const useLocationKey = () => {
  const location = useLocation();
  const { hash, key, state } = location;
  const [locationKey, setLocationKey] = useState(`${hash}_${key}`);
  const locationRef = useRef<any>(null);
  const keysRef = useRef<any>({});
  useEffect(() => {
    const preLocation = locationRef.current;
    const keys = keysRef.current;
    if (!preLocation || isRefreshCondition(location, preLocation)) {
      const _key = `${hash}_${key}`;
      if (!keys[_key] && (state as any)?.refreshPage) {
        keys[_key] = true;
        setLocationKey(_key);
      }
    }
    locationRef.current = location;
  }, [location]);
  return locationKey;
};

export default useLocationKey;
